module.exports = "<app-agency-list></app-agency-list>"


//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/src/app/dashboard/dashboard.component.html
// module id = ../../../../../src/app/dashboard/dashboard.component.html
// module chunks = 1